var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_vm._v("费用结算")]),_vm._v(" "),_c('orderReceipt'),_vm._v(" "),_c('orderPayment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }